import {
  ListItem,
  ListItemButton,
  ListItemText,
  Typography
} from '@mui/material'

import { CustomerEntry } from '../../sdk'
import { formatPhoneNumber } from '../../utils'
import { formatName } from '../../utils/formatCustomerName/formatCustomerName'

interface Props {
  option: CustomerEntry
  handleClick: () => void
}

export const CustomerListItem: React.FC<Props> = ({ option, handleClick }) => {
  return (
    <ListItem sx={{ padding: 0 }}>
      <ListItemButton
        onClick={handleClick}
        aria-label={`searchResult-${option.id}`}>
        <ListItemText
          primary={
            <Typography sx={{ fontWeight: 'bold' }}>
              {formatName(option.information)}
            </Typography>
          }
          secondary={
            <>
              {option.information?.email && (
                <Typography>Email: {option.information?.email}</Typography>
              )}
              {option.information?.phone && (
                <Typography>
                  Phone: {formatPhoneNumber(option.information?.phone)}
                </Typography>
              )}
            </>
          }
        />
      </ListItemButton>
    </ListItem>
  )
}
